import React from 'react'

function LeadHead(props) {
    return (
        <thead className="CustomersHead">
        <tr>
            <th>Tên lead</th>
            <th>NV sale</th>
            <th>Nguồn</th>
            <th>Trạng thái sale</th>
            <th>Trạng thái call</th>
        </tr>
        </thead>
    )
}

export default LeadHead